// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({
//   name: 'filterCod'
// })
// export class FilterCodPipe implements PipeTransform {
//   transform(options: any[], search: string): any[] {
//     if (!options || !search) return options;
//     return options.filter(opt =>
//       opt.cod.toLowerCase().includes(search.toLowerCase())
//     );
//   }
// }

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCod'
})
export class FilterCodPipe implements PipeTransform {
  transform(options: any[], search: string): any[] {
    if (!options || !search) return options;

    const normalizedSearch = this.normalizeCode(search);

    return options.filter(opt =>
      this.normalizeCode(opt.cod).includes(normalizedSearch)
    );
  }

  private normalizeCode(cod: string): string {
    if (!cod) return '';
    return cod
      .toString()
      .toLowerCase()
      // quita ceros innecesarios después del guion
      .replace(/-0*(\d+)$/, '-$1');
  }
}
